import React from "react";

interface LaserBorderProps {
  children: React.ReactNode;
  className?: string;
  bg?: string;
}

const LaserBorder: React.FC<LaserBorderProps> = ({
  children,
  className,
  bg,
}) => {
  return (
    <button
      className={`px-4 py-6 group relative overflow-hidden whitespace-nowrap [background:var(--bg)] [border-radius:var(--radius)]  transition-all duration-300 hover:scale-105 hover:shadow-[0_0_40px_8px_rgba(55,216,184,0.4)] flex justify-center ${className}`}
      style={
        {
          // @ts-ignore
          "--spread": "90deg",
          "--shimmer-color": "#37d8b8",
          "--speed": "1.5s",
          "--radius": "10px",
          "--cut": "0.1em",
          "--bg":
            bg ||
            "radial-gradient(ellipse 80% 50% at 50% 120%,rgba(30, 80, 75),rgba(10, 25, 30))",
        } as React.CSSProperties
      }
    >
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute inset-[-100%] rotate-gradient">
          <div className="absolute inset-0 [background:conic-gradient(from_calc(270deg-(var(--spread)*0.5)),transparent_0,#37d8b8_var(--spread),transparent_var(--spread))]"></div>
        </div>
      </div>
      <div className="absolute [background:var(--bg)] [border-radius:var(--radius)] [inset:var(--cut)]"></div>
      {children}
    </button>
  );
};

export default LaserBorder;
